import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum CreditCardTypeId {
  REGULAR = 0,
  VIRTUAL = 1,
}

export class CreditCardType extends Codebook<CreditCardTypeId> {
  static readonly REGULAR = new CreditCardType(CreditCardTypeId.REGULAR, () => $t('Regular'))
  static readonly VIRTUAL = new CreditCardType(CreditCardTypeId.VIRTUAL, () => $t('Virtual'))

  private constructor(
    id: CreditCardTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
